<div class="w-100 h-100">
    <div class="row d-flex justify-content-center">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.updateMessageTemplateRequest')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-sm-center">
        <div class="col-sm-12">
            <v-stepper alt-labels :value="stepNumber">
                <v-stepper-header>
                    <v-stepper-step step="1"
                                    :class="['stepper-label-nowrap', { 'complete': stepNumber > 1 }]">
                        {{$t('shared.TemplateInfo')}}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2"
                                    :class="['stepper-label-nowrap', { 'complete': stepNumber > 2 }]">
                        {{$t('shared.reviewRequest')}}
                    </v-stepper-step>
                </v-stepper-header>
            </v-stepper>
        </div>
    </div>
    <!-- Step 1 - Template Info -->
    <div class="row" v-if="stepNumber == 1">
        <div class="col-md-12 pr-0">
            <div class="card card_layout">
                <v-container v-if="loadingAIValidation" style="height: 400px;" class="d-flex align-center justify-center">
                    <v-col cols="12" class="d-flex flex-column align-center justify-center">
                        <div class="text-h2 mb-2 text-center">
                            {{ $t('shared.loadingAIValidation') }}
                        </div>
                        <div class="progress-wrapper" style="position: relative; width: 100%; max-width: 800px;">
                            <v-progress-linear rounded height="25" indeterminate color="grey darken-3"
                                class="my-outline-progress"></v-progress-linear>
                            <div class="progress-center-text">
                                <strong>{{ Math.ceil(aiValidationProgress) }}%</strong>
                            </div>
                        </div>
                    </v-col>
                </v-container>
                <div class="card-body card_body_layout" v-else>
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label>{{$t('shared.senderName')}}</label>
                            <input class="form-control" type="text" :value="model.senderName" disabled />
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.classification')}}</label>
                                <v-select v-model="model.classification" :items="filteredClassifications"
                                          :label="$t('shared.select')" item-text="name" item-value="id" solo :disabled="isClassificationDisabled">
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="row m-2">
                        <div class="col-md-12">
                            <label class="user_info_header mb-2">{{$t('shared.suggestedFreeContent')}}</label>
                            <p v-if="!model.classification" class="text-muted small mb-0">
                                {{ $t('shared.selectClassificationForSuggestedContent') }}
                            </p>
                            <template v-else>
                                <p class="text-muted small mb-2">{{ $t('shared.suggestedFreeContentDescription') }}</p>
                                <div v-if="loadingPreApprovedTemplates" class="text-center py-3">
                                    <span class="text-muted">{{ $t('shared.loading') }}</span>
                                </div>
                                <div v-else-if="filteredSuggestedTemplates.length === 0" class="text-center py-3">
                                    <span class="text-muted">{{ $t('shared.noSuggestedTemplates') }}</span>
                                </div>
                                <div v-else class="suggested-templates-scroll">
                                    <div class="row">
                                        <div class="col-md-4 mb-3" v-for="template in filteredSuggestedTemplates" :key="template.id">
                                            <div class="card h-100"
                                                 :class="isSuggestedTemplateSelected(template) ? 'border-primary' : ''"
                                                 :style="isSuggestedTemplateSelectionDisabled ? 'cursor: default; opacity: 0.6;' : 'cursor: pointer;'"
                                                 @click="toggleSuggestedTemplate(template)">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="mb-2">
                                                        <strong>{{ template.name }}</strong>
                                                        <span v-if="template.templateCode" class="text-muted small d-block">{{ template.templateCode }}</span>
                                                    </div>
                                                    <p class="text-muted small mb-3" style="flex: 1;">{{ template.content }}</p>
                                                    <button type="button"
                                                            class="btn btn-sm w-100"
                                                            :class="isSuggestedTemplateSelected(template) ? 'btn-outline-secondary' : 'btn-primary'"
                                                            @click.stop="toggleSuggestedTemplate(template)">
                                                        {{ isSuggestedTemplateSelected(template) ? $t('shared.deselect') : $t('shared.select') }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <hr />

                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.templateName')}}</label>
                                <input class="form-control" type="text" v-model="model.templateName" :disabled="isTemplateDataDisabled" />
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.templateDescription')}}</label>
                                <input class="form-control" type="text" v-model="model.templateDescription" maxlength="160" :disabled="isDescriptionDisabled || isTemplateDataDisabled" />
                                <small v-if="templateDescriptionError" class="text-danger">{{ templateDescriptionError }}</small>
                            </div>
                        </div>
                    </div>

                    <div class="row m-2">
                        <div class="col-md-12 mb-3">
                            <div class="form-group mb-0">
                                <label>
                                    {{$t('shared.templateValue')}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <i class="fas fa-info-circle" v-bind="attrs" v-on="on"></i>
                                        </template>
                                        <span>
                                            <div>{{ $t('shared.organizationNameSuffix') }}: {{ organizationName }}</div>
                                            <div class="mt-1">{{ $t('shared.templateVariableBoundaryInvalid') }}</div>
                                        </span>
                                    </v-tooltip>
                                </label>

                                <small class="text-muted d-block mt-1" v-if="!isSuggestedFreeContentSelected">
                                    {{ $t('shared.addVariableNote') }}
                                </small>

                                <div style="position: relative;" class="mt-1">
                                    <textarea ref="templateContent"
                                              v-model="model.templateContent"
                                              class="form-control"
                                              :disabled="isTemplateDataDisabled"
                                              :style="{
                                                  border: '1px solid #000',
                                                  borderRadius: organizationName ? '15px 15px 0 0' : '15px',
                                                  borderBottom: organizationName ? 'none' : '1px solid #000',
                                                  padding: '10px',
                                                  paddingRight: isSuggestedFreeContentSelected ? '10px' : '60px',
                                                  paddingTop: isSuggestedFreeContentSelected ? '10px' : '12px',
                                                  boxSizing: 'border-box',
                                                  minHeight: '140px',
                                                  color: '#000'
                                              }">
                                    </textarea>
                                    <button v-if="!areVariableActionsDisabled"
                                            type="button"
                                            class="btn d-inline-flex align-items-center justify-content-center text-white"
                                            @click.stop="addVariable"
                                            :title="$t('shared.addVariable')"
                                            style="position: absolute; top: 8px; right: 28px; z-index: 1; background-color: #ff3366; border-color: #ff3366; width: 1.5rem; height: 1.5rem; min-width: 1.5rem; padding: 0; border-radius: 4px; line-height: 1;">
                                        <i class="fas fa-plus" style="font-size: 0.75rem;"></i>
                                    </button>
                                </div>
                                <div v-if="organizationName"
                                     class="form-control"
                                     readonly
                                     tabindex="-1"
                                     style="border: 1px solid #000; border-radius: 0 0 15px 15px; border-top: none; background-color: #f8f9fa; color: #adb5bd; min-height: 38px; cursor: default;">
                                    {{ organizationName }}
                                </div>

                                <div>
                                    <small class="text-muted" v-if="!isSuggestedFreeContentSelected">
                                        {{ $t('shared.templateCharacterCount', { count: templateContentTotalCharacterCount}) }}
                                    </small>
                                    <small class="text-muted" v-if="!isSuggestedFreeContentSelected">{{ $t('shared.charactersRemaining') }}</small>
                                </div>
                                <div class="d-flex justify-content-between mt-2">
                                    <a v-if="regulationsPdfUrl" href="#" class="link_light" @click.prevent="openRegulationsPdf">
                                        {{ $t('shared.smsTemplateRegulationsLink') }}
                                    </a>
                                </div>

                                <small v-if="aiValidationRemarks" class="text-danger d-block mt-1">
                                    {{ aiValidationRemarks }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="col-md-6 pt-1" v-if="templateVariableExamples.length > 0">
                            <ul class="list-group list_Sender scrollbar mb-3">
                                <li class="list-group-item d-flex align-items-center" v-for="(example, index) in templateVariableExamples" :key="index">
                                    <span style="font-weight: bold; margin-right: 10px;">Var{{ index + 1 }}:</span>

                                    <input class="form-control form-control-sm"
                                           type="text"
                                           :value="example"
                                           :disabled="isTemplateDataDisabled"
                                           @input="setVariableExample(index + 1, $event.target.value)"
                                           style="flex: 1; margin-right: 10px;" />

                                    <i v-if="!isTemplateDataDisabled"
                                       class="far fa-trash-alt Icon_delete"
                                       @click="deleteVariable(index + 1)"
                                       style="cursor: pointer; color: #dc3545;"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <input type="checkbox" v-model="model.isExpressProcessing" :disabled="isProcessingDurationDisabled" />
                                <label class="mb-0 mr-2">{{$t('shared.speedUpApproval')}}</label>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div class="row m-2">
                        <div class="col-md-12">
                            <label class="user_info_header mb-2 d-inline-flex align-items-center" style="gap:4px">
                                {{$t('shared.licensesAndApproval')}}
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <i class="fas fa-info-circle" v-bind="attrs" v-on="on"></i>
                                    </template>
                                    <span style="white-space: pre-line;">{{ attachmentTooltip }}</span>
                                </v-tooltip>
                            </label>
                            <div class="row" v-if="canUploadMoreLicenseAttachments">
                                <div class="col-md-6 col-5 pt-1">
                                    <div class="form-group">
                                        <div class="input-group mb-3">
                                            <input type="file" ref="fileName" hidden
                                                   accept=".pdf,application/pdf" @change="onFilePicked">
                                            <input :placeholder="$t('shared.addAttachment')" @click="onPickFile"
                                                   class="form-control border-right-0 border-left"
                                                   readonly
                                                   style="cursor: pointer; background-color: #fff;"
                                                   v-model="selectedFileName" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group-prepend pt-1">
                                    <span style="padding: 4px;">
                                        <button :disabled="!canAddAttachment" @click="addAttachment"
                                                class="btn btn-primary">
                                            {{$t('shared.add')}}
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6 col-5 pt-1">
                                <ul class="list-group list_Sender scrollbar">
                                    <li class="list-group-item" v-for="(attachment, index) in visibleAttachments" :key="attachment.id || index">
                                        <span style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ attachment.fileName }}</span>
                                        <i class="far fa-trash-alt Icon_delete" style="cursor: pointer;" @click="deleteAttachment(index)"></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer" v-if="!loadingAIValidation">
                    <div class="form-row justify-content-between align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_light" @click="reset" v-if="stepNumber == 1">{{$t('shared.reset')}}</a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-outline-primary px-5 py-2 mx-2" @click="back" v-if="stepNumber > 1">
                                {{$t('shared.back')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" @click="next" :disabled="!isValidStep" v-if="stepNumber < 2">
                                {{$t('shared.next')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Step 2 - Review -->
    <div class="row" v-if="stepNumber == 2">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout" v-if="isSubmitted">
                    <div class="d-flex flex-column align-items-center justify-content-center" style="min-height:300px;">
                        <img class="pb-4" :src="require('../../img/BigCheck.svg')" style="width: 120px;" />
                        <label class="w-100 pb-4 text-center" style="font-size: 1.4rem;">
                            {{$t('shared.requestSubmittedSuccessfully')}}
                        </label>
                        <div class="form-row justify-content-center align-items-center mt-3">
                            <div class="col-auto mx-3">
                                <router-link to="/MessageTemplateDashboard" tag="button"
                                             class="btn btn-outline-primary px-5 py-2 mx-2">
                                    {{$t('shared.requestsListPage')}}
                                </router-link>
                            </div>
                            <div class="col-auto mx-3">
                                <router-link to="/MessageTemplateReqeust" tag="button"
                                             class="btn btn-primary px-5 py-2">
                                    {{$t('shared.newRequest')}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body card_body_layout" v-if="!isSubmitted">
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="card_header_orders" style="font-weight:bold !important; color:#1a1a1a !important;">{{$t('shared.clientInformation')}}</label>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.clientName')}}</label>
                            <h4 class="user_info_txt">{{model.clientName || '-'}}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.customerType')}}</label>
                            <h4 class="user_info_txt">{{getCustomerTypeText(model.customerType)}}</h4>
                        </div>
                        <div class="col-md-4 mb-3" v-if="model.customerType !== 3">
                            <label class="user_info_header mb-0" v-if="model.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                            <label class="user_info_header mb-0" v-if="model.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                            <label class="user_info_header mb-0" v-if="model.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                            <h4 class="user_info_txt">{{model.crNumber || '-'}}</h4>
                        </div>
                        <div class="col-md-4 mb-3" v-if="model.customerType === 2 || model.customerType === 3">
                            <label class="user_info_header mb-0">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                            <h4 class="user_info_txt">{{model.enterpriseUnifiedNumber || '-'}}</h4>
                        </div>

                        <div class="col-md-12 mb-3 mt-2">
                            <label class="card_header_orders" style="font-weight:bold !important; color:#1a1a1a !important;">{{$t('shared.senderInformation')}}</label>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.senderName')}}</label>
                            <h4 class="user_info_txt">{{model.senderName || '-'}}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.senderType')}}</label>
                            <h4 class="user_info_txt">{{concatenatedSenderTypes || '-'}}</h4>
                        </div>

                        <div class="col-md-12 mb-3 mt-2">
                            <label class="card_header_orders" style="font-weight:bold !important; color:#1a1a1a !important;">{{$t('shared.templateInformation')}}</label>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.templateName')}}</label>
                            <h4 class="user_info_txt">{{model.templateName || '-'}}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.classification')}}</label>
                            <h4 class="user_info_txt">{{getClassificationText(model.classification)}}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.templateDescription')}}</label>
                            <h4 class="user_info_txt">{{model.templateDescription || '-'}}</h4>
                        </div>
                        <div class="col-md-12 mb-3" v-if="hasTemplateVariables">
                            <table class="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th style="width: 50%;">{{$t('shared.templateContent')}}</th>
                                        <th style="width: 50%;">{{$t('shared.previewContent')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="text-align: start; white-space: pre-wrap;">{{ baseTemplateContent }}</td>
                                        <td style="text-align: start; white-space: pre-wrap;">{{ substitutedFullContent }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-12 mb-3" v-else>
                            <label class="user_info_header mb-0">{{$t('shared.templateValue')}}</label>
                            <textarea :value="baseTemplateContent"
                                      class="form-control"
                                      readonly
                                      disabled
                                      tabindex="-1"
                                      :style="{
                                          border: '1px solid #000',
                                          borderRadius: organizationName ? '15px 15px 0 0' : '15px',
                                          borderBottom: organizationName ? 'none' : '1px solid #000',
                                          padding: '10px',
                                          minHeight: '140px',
                                          color: '#000',
                                          backgroundColor: '#fff',
                                          cursor: 'default'
                                      }">
                            </textarea>
                            <div v-if="organizationName"
                                 class="form-control"
                                 readonly
                                 tabindex="-1"
                                 style="border: 1px solid #000; border-radius: 0 0 15px 15px; border-top: none; background-color: #f8f9fa; color: #adb5bd; min-height: 38px; cursor: default;">
                                {{ organizationName }}
                            </div>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div class="col-md-12 mb-3 mt-2">
                                <label class="card_header_orders" style="font-weight:bold !important; color:#1a1a1a !important;">{{$t('shared.licensesAndApproval')}}</label>
                            </div>
                            <ul class="user_info_header row mb-0" v-if="visibleAttachments.length > 0">
                                <li style="list-style:none"
                                    v-for="(item, index) in visibleAttachments" :key="item.id || index">
                                    <div class="col-md-12 mb-3">
                                        <h4 class="user_info_txt">
                                            <span class="badge badge-primary"
                                                  style="max-width: 100%; width: auto; height: auto; min-height: 24px; white-space: normal; word-break: break-word; overflow: visible; text-overflow: clip; line-height: 1.4; padding: 6px 28px 6px 8px;">
                                                <i class="fas fa-paperclip"></i>{{item.fileName}}
                                            </span>
                                        </h4>
                                    </div>
                                </li>
                            </ul>
                            <div class="col-md-4 mb-3" v-if="visibleAttachments.length === 0">
                                <label class="user_info_header mb-0">
                                    {{$t('shared.noAttachments')}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer" v-if="!isSubmitted">
                    <div class="form-row justify-content-between align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="cancel">{{$t('shared.cancel')}}</a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-outline-primary px-5 py-2 mx-2" @click="back">
                                {{$t('shared.back')}}
                            </button>
                            <button class="btn btn-primary px-5 py-2" @click="showsubmitRequestDialog">
                                {{$t('shared.submit')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- submit modal  -->
    <div class="text-xs-center">
        <v-dialog v-model="submitRequestdialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.editInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hidesubmitRequestDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.updateMessageTemplateRequestInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hidesubmitRequestDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="submitRequest">
                                {{$t('shared.Ok')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>